export enum SubscriptionTypesEnum {
    MONTHLY = 1,
    YEARLY
}